/**
 * @title addressSelectionDialog.js: Feature level module
 * @description Address utility module
 */
define(['address', 'addressDisplay'], function(address, addressDisplay) {
  var CAddressSelectionDialog = {
    createAddressSelectionContent: function(currentAddressId, type, addressTemplates, templateOptions) {
      let address_block_html = "",
        labels = address.getHeaderLabels(type, 'choose'),
        addressJson = address.getAddressJson(type, currentAddressId);
      	let template =  ""
      	addressJson.forEach((address, i) => {
    	  if(address.isPrimary == "1") {
  	        // Default address
    		template = "tmpl_choose_default_address_block";
    	  } else {
    		// Non-default address
      		template = addressTemplates.addressBlock;
    	  }
        address_block_html += COSTCO.util.tmpl(template, {
        	currentAddressId: currentAddressId === undefined ? "''" : currentAddressId,
          type: type,
          id: address.id,
          editButton: labels.editButton,
          address: addressDisplay.createAddressDisplay(address, type),
          orderItemId: templateOptions.orderItemId === undefined ? "''" : templateOptions.orderItemId,
          multiShip: templateOptions.multiShip === undefined ? "''" : templateOptions.multiShip
        });
      })
      var needsSearchVal=false;
      var needsSortVal=false;
      var needsNotificationVal=false;
      var recentSortVal=$('#recentSort').val();
      var firstNameZToASortVal=$('#firstNameZToASort').val();
      var firstNameAToZSortVal=$('#firstNameAToZSort').val();
      var lastNameAToZSortVal=$('#lastNameAToZSort').val();
      var lastNameZToASortVal=$('#lastNameZToASort').val();
      var companyNameAToZSortVal = $('#companyNameAToZSort').val();
      var companyNameZToASortVal = $('#companyNameZToASort').val();
      var sortSelectVal=$('#sortSelect').val();
      if($('#isBDAppVar').val() == 'BD'){
    	  needsSearchVal=false;
    	  needsSortVal=addressJson.length >= 20;
      }
      else{
    	  needsSearchVal= addressJson.length >= 20;
    	  needsSortVal=false;
      }
      if (typeof templateOptions.needsNotification != 'undefined') {
      	needsNotificationVal = templateOptions.needsNotification;
      }
      
      // This is the container for the address blocks. Represents the content
      // of the modal.
      return COSTCO.util.tmpl(addressTemplates.wrapper, {
        type: type,
        orderItemId : templateOptions.orderItemId,
        shipTo: labels.shipTo,
        headerText: labels.headerText,
        addNewAddress: labels.addNewAddress,
        addressChooseBlocks: address_block_html,
        needsSearch: needsSearchVal,
        needsSort: needsSortVal,
        needsNotification: needsNotificationVal,
        recentSort: recentSortVal,
        firstNameZToASort: firstNameZToASortVal,
        firstNameAToZSort: firstNameAToZSortVal,
        lastNameAToZSort: lastNameAToZSortVal,
        lastNameZToASort: lastNameZToASortVal,
        companyNameAToZSort: companyNameAToZSortVal,
        companyNameZToASort: companyNameZToASortVal,
        currentAddressId: (typeof currentAddressId === 'undefined') ?  "''" : currentAddressId,
        sortSelect: sortSelectVal,
      });
    },
    showAddressSelectionDialog: function(addressId, type, orderItemId, multiShip, templateOptions, mode) {
      COSTCO.util.getAddressBatchPage(type, 'FIRSTNAME', 'ASC', '96', function(data) {
        let addressTemplates = {};
        addressTemplates.addressBlock = 'tmpl_choose_address_block';
        addressTemplates.wrapper = 'tmpl_choose_address_wrapper';
        addressTemplates.footerText = undefined;
        
        if (typeof templateOptions != 'object') {
        	templateOptions = {};
        }
        templateOptions.orderItemId = orderItemId;
        templateOptions.multiShip = multiShip;
        templateOptions.mode = mode
        COSTCO.CAddressSelectionDialog.createModal(addressId, type, addressTemplates, templateOptions);
        if (event !== undefined) {
          let callerElement = event.target;
          COSTCO.dialog.returnFocusOnCallerElement(callerElement);
        }
      });
    },
    createModal: function(addressId, type, addressTemplates, templateOptions) {
    	
      var body = COSTCO.CAddressSelectionDialog.createAddressSelectionContent(addressId, type, addressTemplates, templateOptions);
      let headerText = '';
      if (addressTemplates.headerText) {
      	
        let displayText = '';
      	if (type == 'S') {
      		displayText = addressLabels.choose.shipping.headerText;
      	} else if (type == 'B') {
      		displayText = addressLabels.choose.billing.headerText;
      	}
      	
      	headerText = COSTCO.util.tmpl(addressTemplates.headerText, {headerText: displayText});
      }
      let mode = (typeof templateOptions.mode !== 'undefined') ? templateOptions.mode : 'choose';
      address.baseModal(type, mode, {
    	  body: body,
		secondary_event: function() { COSTCO.CAddressSelectionDialog.handleClose(addressId, templateOptions.orderItemId) },
	    close: function() { COSTCO.CAddressSelectionDialog.handleClose(addressId, templateOptions.orderItemId) }
      });
    },
    
    handleClose: function(addressId, orderItemId){
		$('#costcoModal').modal('hide');
		$('#address_change_' + addressId + '_' + orderItemId).focus();
	},
    
    handleRadioButtonClick: function(element) {
      $('#costcoModalBtn2').removeClass('btn-disabled');
    },
    /**
     * This function is called when the select button is clicked in the address choose modal
     */
    handleAddressSelection: function(addressId, newAddressId, orderItemId) {
    	
    	if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
    		document.getElementById("calendarServiceResponse").value = "";
    	}
      if(typeof(sessionStorage) !== "undefined"){
    	sessionStorage.setItem('shipping-costs-orderItemId', orderItemId);
    	sessionStorage.setItem('shipping-costs-addressId', newAddressId);
      }
      address.chooseAddress(addressId, newAddressId, orderItemId);
      if(!(COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && typeof checkoutPage != 'undefined')){
    	  $('#costcoModal').modal('hide');
      }
      
    },
    /**
     * These are the address blocks that are used in the "Choose
     * a X Address" modal.
     * @param  {array} addresses Array of address objects
     * @param  {String} type     The type of address we're making 'S' or
     *                           'B'
     * @param  {array} currentAddressId Array of currentAddressId(String) of length 1
     * @param  {array} orderItemId Array of orderItemId(String) of length 1                          
     * @return {void}
     */
    buildAddressBlocks: function(addresses, type, currentAddressId, orderItemId) {
      let util = COSTCO.util;
      let address_block_html = "";
      if (addresses.length > 0) {
        let labels = address.getHeaderLabels(type, 'choose');
        $('#address-blocks').children().remove();
        
        addresses.forEach((addr, i) => {
          // Normalizing property values of each address object
          util.renameArray(addr, util.addressNamingMap);
          addr.addressType = addr.addressType.trim();
          address_block_html += util.tmpl('tmpl_choose_address_block', {
            checked: i === 0 ? "checked" : "",
            type: type,
            id: addr.id,
            editButton: labels.editButton,
            address: addressDisplay.createAddressDisplay(addr, type),
            orderItemId : (typeof orderItemId === 'undefined' || orderItemId.length == 0 ||  typeof orderItemId[0] == 'undefined' || orderItemId[0] == '' ) ? "''" : orderItemId[0],
            currentAddressId : (typeof currentAddressId === 'undefined' || currentAddressId.length == 0 || typeof currentAddressId[0] == 'undefined' || currentAddressId[0] == '' ) ? "''" : currentAddressId[0], 
            multiShip:  "''"
          });
        });
        util.concatNonDuplicates(addresses);
        $('#address-blocks').append(address_block_html);
      }
    },
    sortAddressList: function() {
    	let $sortOption = $('.checkout-address-book-select').find('option:selected').val();
    	let util = COSTCO.util;
    	let type = $('#address-sort-form').find('input[name=addressType]').val();
    	if($sortOption == '2'){
    		$('#address-sort-form').find('input[name=filterName]').val('firstname');
    		$('#address-sort-form').find('input[name=filterOrder]').val('ASC');
    	}else if($sortOption == '3'){
    		$('#address-sort-form').find('input[name=filterName]').val('firstname');
    		$('#address-sort-form').find('input[name=filterOrder]').val('DESC');
    	}else if($sortOption == '5'){
    		$('#address-sort-form').find('input[name=filterName]').val('lastname');
    		$('#address-sort-form').find('input[name=filterOrder]').val('ASC');
    	}else if($sortOption == '6'){
    		$('#address-sort-form').find('input[name=filterName]').val('lastname');
    		$('#address-sort-form').find('input[name=filterOrder]').val('DESC');
    	}else if($sortOption == '7'){
    		$('#address-sort-form').find('input[name=filterName]').val('companyname');
    		$('#address-sort-form').find('input[name=filterOrder]').val('ASC');
    	}else if($sortOption == '8'){
    		$('#address-sort-form').find('input[name=filterName]').val('companyname');
    		$('#address-sort-form').find('input[name=filterOrder]').val('DESC');
    	}
    	util.ajax({
            url: '/AjaxCostcoGetAddressCmd',
            method: 'GET',
            dataType: 'json',
            data: $('#address-sort-form').serializeArray(),
            done: function(data, textStatus, jqXHR, options) {
              try {
                let addresses = JSON.parse(data.addresses);
                if (!data.addresses || addresses.length == 0) {
                  throw new Error("No addresses")
                }
                CAddressSelectionDialog.buildAddressBlocks(addresses, type, data.currentAddressId, data.orderItemId);
              } catch (e) {
                $('.address-search .error').removeClass('hide');
                console.error(e)
              }
            },
            fail: function(jqXHR, textStatus, errorThrown) {
              console.error(errorThrown)
            }
          })
      },
    /**
     * Used in the "Choose a X Address" modal (Checkout Shipping) to allow
     * the user to search for addresses in their address book by first and
     * last name. Made specifically for users that have tons of addresses.
     * This function is used on the form located in CheckoutTemplates.jspf.
     * @return {void}
     */
    addressSearch: function() {
      let $firstName = $(this).find('input[name=firstName]');
      let $lastName = $(this).find('input[name=lastName]');
      $firstName.val($firstName.val().trim());
      $lastName.val($lastName.val().trim());
      let type = $(this).find('input[name=addressType]').val();
      let util = COSTCO.util;
      $('.address-search .error').addClass('hide');
      if (!$firstName.val() && !$lastName.val()) {
        // Empty, don't make server call. Just use addresses we have.
        $('.address-search .error').removeClass('hide');
        CAddressSelectionDialog.buildAddressBlocks(util.addresses, type);
        return;
      }
      util.ajax({
        url: '/AjaxCostcoGetAddressCmd',
        method: 'GET',
        dataType: 'json',
        data: $(this).serializeArray(),
        done: function(data, textStatus, jqXHR, options) {
          try {
            let addresses = JSON.parse(data.addresses);
            if (!data.addresses || addresses.length == 0) {
              throw new Error("No addresses")
            }
            CAddressSelectionDialog.buildAddressBlocks(addresses, type, data.currentAddressId, data.orderItemId);
          } catch (e) {
            $('.address-search .error').removeClass('hide');
            console.error(e)
          }
        },
        fail: function(jqXHR, textStatus, errorThrown) {
          console.error(errorThrown)
        }
      })
    }
  }
  if (typeof window.COSTCO === "undefined") {
    window.COSTCO = new Object();
  }
  window.COSTCO.CAddressSelectionDialog = CAddressSelectionDialog;
  return CAddressSelectionDialog;
});


// WEBPACK FOOTER //
// ./js/address/addressSelectionDialog.js